import "../../../../assets/css/AddCatalogs.css";
import React from "react";
import NewButton from "../../../../components/Atomos/Buttons/newButton";
import Modal from "../../../../components/Atomos/Modals/Modal";
import Cancel from "../../../../components/Atomos/Icons/Close";
import Success from "../../../../components/Atomos/Icons/Success";

interface IMainBoxUpdateMembershipProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmation: any;
    title: string;
    message: string; 
    additionalText?: string[];
}

const ModalConfirmation: React.FC<IMainBoxUpdateMembershipProps> = ({
    openModal,
    setOpenModal,
    setConfirmation,
    title,
    message,
    additionalText
}) => {

  return (
    <>
      <Modal
        isModalOpen={openModal}
        toggleModal={() => {
          setConfirmation(false);
          setOpenModal(false);
        }}
        title={title}
        compact
        compactBodyScrolls={false}
        className="max-w-lg w-full"
      >
        <div className="flex flex-col gap-3">
          <p className="text-gray-font text-base font-normal leading-6">
            {message}
          </p>
          {additionalText && additionalText.length > 0 && (
            <ul className="list-disc pl-5 text-gray-font text-sm font-semibold leading-6">
              {additionalText.map((text) => (
                <li key={text}>{text}</li>
              ))}
            </ul>
          )}
          <div className="mt-2 flex flex-wrap justify-end gap-3 border-t border-neutral-200 pt-4">
            <NewButton
              text="Cancel"
              icon={<Cancel />}
              style="outlined"
              size="medium"
              content="textIcon"
              onClick={() => {
                setConfirmation(false);
                setOpenModal(false);
              }}
              color="neutral"
              className="!w-auto shrink-0"
            />
            <NewButton
              text="Confirm"
              icon={<Success />}
              style="filled"
              size="medium"
              content="textIcon"
              onClick={() => {
                setConfirmation(true);
                setOpenModal(false);
              }}
              color="accent"
              className="!w-auto shrink-0"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalConfirmation;
